import React from "react";

const Abotcard = () => {
  const coreValues = {
    pursueExcellence: {
      title: "Pursue Excellence",
      description:
        "We want to be the best in the world at what we do, both as a team and as individuals and understand that excellence builds genuine happiness.",
      color: "#F2F7FF",
    },
    customerServiceFocus: {
      title: "Customer-Service Focus",
      description:
        "We believe that success comes from the process of acting, receiving feedback, and iterating – repeatedly. With this process, almost anything is achievable.",
      color: "#FFFAF2",
    },
    noShortcuts: {
      title: "No Shortcuts",
      description:
        "In an industry where customer service is lacking, excellence in customer-service gives us the opportunity to dominate the market.",
      color: "#FFF5F5",
    },
    overCommunicate: {
      title: "Over Communicate",
      description:
        "Open and direct communication is critical to our success. We constantly communicate to make sure problems are identified and resolved as quickly as possible.",
      color: "#F2FFFB",
    },
    craftsmanshipQuality: {
      title: "Craftsmanship & Quality",
      description:
        "We don’t take shortcuts - we do things the right way. We do the little things right, consistently, every day, which allows us to get the big things right.",
      color: "#F2FFFB",
    },
  };

  return (
    <div>
      <div className="about-card-content">
        <h1
          style={{
            fontSize: window.innerWidth < 768 ? 20 : 40,
            color: "black",
            paddingLeft: window.innerWidth < 768 ? 0 : "2rem",
            textAlign: "center",
            paddingTop: "2rem",
          }}
        >
          Culture values
        </h1>
        <div className="about-card-container mainContainer">
          {Object.values(coreValues).map((item, index) => {
            return (
              <div key={index} className="about-card" style={{ backgroundColor: item.color }}>
                <h3 className="about-title">{item.title}</h3>
                <p className="about-description">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Abotcard;
